import { Injectable } from '@angular/core';

Injectable()
export class DownloadService{
    
    constructor() {
        
    }

    download(path: string,name:string, ext:string = null){
        let link = document.createElement("a");
        link.download = `${name}${ext? ext : '.pdf'}`;
        
        link.href = `./assets/dokumentumok/${path}${ext? ext : '.pdf'}`;
        console.log(link.href);
        link.click();

    }
}